/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-505.139,-3697.66)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,-54.5191,122.825)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M298,595c-0.003,0 -0.007,0 -0.01,0c-19.277,0 -35.14,15.863 -35.14,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c-0.016,-19.267 -15.863,-35.118 -35.13,-35.14m0,65.89c-0.003,0 -0.007,0 -0.01,0c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c-0.005,16.868 -13.872,30.753 -30.74,30.78"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M284.77,621.39l4.39,0c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2l-4.39,0c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M306.73,621.39l4.39,0c1.207,0 2.2,-0.993 2.2,-2.2c0,-1.207 -0.993,-2.2 -2.2,-2.2l-4.39,0c-1.207,0 -2.2,0.993 -2.2,2.2c0,1.207 0.993,2.2 2.2,2.2"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M298,634.56c-7.08,0 -12.87,3.29 -17.2,9.76c-0.211,0.345 -0.323,0.743 -0.323,1.147c0,1.207 0.993,2.2 2.2,2.2c0.7,0 1.359,-0.333 1.773,-0.897c3.51,-5.26 8,-7.82 13.55,-7.82c5.55,0 10,2.56 13.54,7.82c0.404,0.618 1.092,0.994 1.83,1c0.003,0 0.005,0 0.008,0c1.201,0 2.19,-0.989 2.19,-2.19c0,-0.439 -0.132,-0.867 -0.378,-1.23c-4.33,-6.47 -10.12,-9.76 -17.19,-9.76"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
